import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { APIService } from 'src/app/services/APIService';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { DashboardService } from 'src/app/services/dashboard.service';
import { MessagesService } from 'src/app/services/messages.service';
import { AuctionService } from 'src/app/services/auction.service';
import { ConstantsModule } from 'src/app/services/constants.module';
import { AuctionItemOpened } from 'src/app/models/dataModels';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-active-auction-banner',
    templateUrl: './active-auction-banner.component.html',
    styleUrls: ['./active-auction-banner.component.css'],
    standalone: false
})
export class ActiveAuctionBannerComponent extends APIService implements OnInit, OnDestroy {

  constructor(localUtil: LocalUtilService,
    location: Location,
    router: Router,
    public dashboardService: DashboardService,
    public auctionService: AuctionService,
    public messageService: MessagesService,
    translateService: TranslateService) {
        super(localUtil, location, router, translateService);
  }

  dataFineAstaInCorso: string;
  oraFineAstaInCorso: string;
  visible: boolean = true;
  auctionsOpened: AuctionItemOpened[] = [];
  private subscriptions: Subscription[] = [];
  @Output() ready = new EventEmitter();

  ngOnInit(): void {
    this.searchOpenedAuction();
  }

  searchOpenedAuction() {
    try {
      const service = this.auctionService.listaAste(ConstantsModule.AUCTION_STATUS_INPROGRESS).subscribe(
        res => {
          if(res.list!=undefined && res.list.length >0){
            res.list.forEach(item => {
              let aucItem: AuctionItemOpened = new AuctionItemOpened();
              aucItem.codiceAsta = item.codiceAsta;
              aucItem.dataFineAsta = item.dataOraFineAsta.split(" ")[0];
              aucItem.oraFineAsta = item.dataOraFineAsta.split(" ")[1];    
              aucItem.visible = true;
              this.auctionsOpened.push(aucItem);
              this.ready.emit(true);
            });
          }
        }, this.handleError(true));
        this.subscriptions.push(service);
        setTimeout("$('.auctions-list').masonry({itemSelector: '.auction-item',columnWidth: 330,gutter: 30});", 500);
      } catch (err) {
        console.log(err);
      }
  }

  isRoutingAsteInCorso() {
    return this.router.url.indexOf(ConstantsModule.USER_ASTE_IN_CORSO__NO_DASHB) > -1;
  }

  ngOnDestroy() {
    try {
      this.subscriptions.forEach(sub => {
                
        sub.unsubscribe()
      });
    } catch (err) {
      //
    }
  }

}
